module.exports = __webpack_public_path__ + "6fd1361a03f7cf3438b3aab6bc409c7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.jpg
// module id = 227
// module chunks = 0